import React, { lazy, Suspense ,useEffect} from "react";
import { ErrorBoundary } from "react-error-boundary";
import { ToastContainer } from 'react-toastify';
import BackDrop from "components/backDrop/BackDrop";
import AppError from "./components/error/Error";
import { companyDetails } from 'utils/companyDetails';
import "assets/styles/Style.scss";
const AppRouter = lazy(() =>
  import(/* webpackChunkName: "App" */ "./routes/AppRoutes")
);

function App() {
  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link)
        ;
    }
    link.href = companyDetails?.favicon;
    document.title = companyDetails?.companyName;
  }, []);
  return (
    <Suspense fallback={<div className="loading" />}>
      <ErrorBoundary FallbackComponent={AppError}>
        <AppRouter />
        <BackDrop />
        <ToastContainer />
      </ErrorBoundary>
    </Suspense>
  );
}

export default App;
